import { render, staticRenderFns } from "./BarConsultationsISTByRaisonsVenue.vue?vue&type=template&id=b5d6a360&"
import script from "./BarConsultationsISTByRaisonsVenue.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByRaisonsVenue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports